export const EXTRA_SEARCH_MAP = {
  'minCapacity': 'min_capacity',
  'minLength': 'min_length',
  'minWidth': 'min_width',
  'minHeight': 'min_height',
}
